import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/TS_InputV2';
export class Dialog_DemoEventLabel extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.label ??= nextProps.defaultLabel ?? '';
        return state;
    }
    onSubmit = () => {
        const label = this.state.label.trim();
        if (!label)
            return;
        this.props.onSubmit(label);
    };
    render() {
        return (_jsxs(LL_V_L, { className: 'ehr-emulator__demo-event-label-dialog', children: [_jsx(LL_H_C, { className: 'ehr-emulator__demo-event-label-dialog__header', children: "Set demo event label" }), _jsx("div", { className: 'ehr-emulator__demo-event-label-dialog__body', children: _jsx(TS_InputV2, { type: "text", value: this.state.label, onChange: (value) => this.setState({ label: value }), placeholder: "Label", focus: true }) }), _jsxs(LL_H_C, { className: 'ehr-emulator__demo-event-label-dialog__actions', children: [_jsx(Button, { variant: 'tertiary', onClick: this.props.onCancel, children: "Cancel" }), _jsx(Button, { variant: 'primary', disabled: !this.state.label.trim(), onClick: this.onSubmit, children: "Save" })] })] }));
    }
}
//# sourceMappingURL=Dialog_DemoEventLabel.js.map